import { ref } from 'vue'
import html2canvas from 'html2canvas'
import { ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage'
import { getFirebaseStorage } from '@core/firebase/firebase'
import { callFunction } from '@core/firebase/functions'
import { useToast } from '@core/composables/useToast'

export function useWhatsapp() {
  const loading = ref(false)
  const toast = useToast()

  function transformPhone(phone) {
    if (!phone) return null
    if (phone.includes('-')) return phone
    let p = phone.replace('05', '9725')
    if (p.includes(',')) return p.split(',')
    return p
  }

  async function sendToTargets(images, rawPhone) {
    const phone = transformPhone(rawPhone)
    if (!phone) return false

    try {
      if (Array.isArray(phone)) {
        for (const p of phone) {
          await callFunction('whatsappPostImages', { phone: p, images })
        }
      } else {
        await callFunction('whatsappPostImages', { phone, images })
      }
      return true
    } catch (err) {
      console.error(err)
      return false
    }
  }

  async function captureAndUpload(elementIds, storagePath = 'cards') {
    const storage = getFirebaseStorage()
    const downloadUrls = []

    for (const id of elementIds) {
      const element = document.getElementById(id)
      if (!element) continue

      try {
        const cardRef = storageRef(storage, `${storagePath}/${id}.png`)
        const canvas = await html2canvas(element, { useCORS: true })
        const blob = await new Promise((r) => canvas.toBlob(r, 'image/png'))
        await uploadBytes(cardRef, blob)
        downloadUrls.push(await getDownloadURL(cardRef))
      } catch (err) {
        console.error('Upload failed:', err)
      }
    }

    return downloadUrls
  }

  async function captureAndUploadWithCache(elementIds, storagePath = 'cards') {
    const storage = getFirebaseStorage()
    const downloadUrls = []

    for (const id of elementIds) {
      const element = document.getElementById(id)
      if (!element) continue

      try {
        const cardRef = storageRef(storage, `${storagePath}/${id}.png`)
        let downloadUrl
        try {
          downloadUrl = await getDownloadURL(cardRef)
        } catch (err) {
          if (err.code === 'storage/object-not-found') {
            const canvas = await html2canvas(element, { useCORS: true })
            const blob = await new Promise((r) => canvas.toBlob(r, 'image/png'))
            await uploadBytes(cardRef, blob)
            downloadUrl = await getDownloadURL(cardRef)
          } else {
            throw err
          }
        }
        downloadUrls.push(downloadUrl)
      } catch (err) {
        console.error('Upload failed:', err)
      }
    }

    return downloadUrls
  }

  return {
    loading,
    toast,
    transformPhone,
    sendToTargets,
    captureAndUpload,
    captureAndUploadWithCache,
  }
}
